import React from "react";
import path from '../../../img/partners/beetroot.png'

const Beetroot: React.FunctionComponent = () => (
  <img src={path} />
)

export default Beetroot
